module.exports = __webpack_public_path__ + "img/logoname.3c00d68d.png";